import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

export default function WelcomeModal() {
  const { user, dismissWelcome } = useAuth();
  const [closing, setClosing] = useState(false);

  const close = async () => {
    setClosing(true);
    await dismissWelcome();
  };

  return (
    <div
      role="dialog"
      aria-modal="true"
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 1100, padding: '20px',
      }}>
      <div style={{
        background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: '14px',
        maxWidth: '440px', width: '100%',
        boxShadow: 'var(--shadow-modal)',
        padding: '32px 32px 28px',
      }}>
        <p style={{ fontSize: '11px', color: 'var(--acc)', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '8px' }}>
          ScanPilots
        </p>
        <h2 style={{ fontSize: '22px', fontWeight: 700, color: 'var(--ink)', margin: '0 0 12px', lineHeight: 1.25 }}>
          Cześć {user?.imie || 'fotografie'}, witaj w ScanPilots!
        </h2>
        <p style={{ fontSize: '13px', color: 'var(--ink2)', margin: '0 0 8px', lineHeight: 1.6 }}>
          Aplikacja pomoże Ci zarządzać klientami, spacerami Matterport i rozliczeniami hostingu — wszystko w jednym miejscu.
        </p>
        <p style={{ fontSize: '13px', color: 'var(--ink2)', margin: '0 0 16px', lineHeight: 1.6 }}>
          Na dashboardzie znajdziesz checklistę z krokami na start, którą możesz odhaczyć w dowolnej kolejności.
        </p>
        <p style={{ fontSize: '13px', color: 'var(--ink2)', margin: '0 0 16px', lineHeight: 1.6 }}>
          Wszystkie wprowadzone dane (klienci, spacery, faktury) <strong style={{ color: 'var(--ink)' }}>zostaną zachowane</strong>, jeśli po becie zdecydujesz się korzystać z ScanPilots dalej.
        </p>
        <p style={{ fontSize: '13px', color: 'var(--ink2)', margin: '0 0 24px', lineHeight: 1.6 }}>
          Z pytaniami i feedbackiem pisz na <strong style={{ color: 'var(--ink)' }}>hello@scanpilots.com</strong> albo przez Wsparcie (czat) w aplikacji — odpowiem w ciągu kilku godzin.
        </p>

        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <button
            onClick={close}
            disabled={closing}
            style={{
              padding: '10px 24px', borderRadius: '8px', border: 'none',
              background: 'var(--acc)', color: '#fff',
              fontSize: '13px', fontWeight: 700, cursor: 'pointer',
              opacity: closing ? 0.6 : 1,
            }}>
            {closing ? '…' : 'Zaczynamy'}
          </button>
        </div>
      </div>
    </div>
  );
}
